import React from 'react';
import { Sparkles } from 'lucide-react';
import { galleryImages, galleryVideos } from '../../data/siteData';

export const Gallery = ({ onSelectImage }) => {
  return (
    <section id="galerie" className="py-24 px-4 sm:px-6 lg:px-8 bg-white" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-blue-100 text-[#0205B3] px-4 py-2 rounded-full text-sm font-medium mb-4">
            <Sparkles className="h-4 w-4" />
            <span>Notre galerie</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Qualité et perfection dans chaque détail
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Découvrez quelques exemples de notre travail soigné
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {/* Vidéos en premier */}
          {galleryVideos.map((video, idx) => (
            <div
              key={video.url}
              className={`group relative aspect-square overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 ${idx === 0 ? 'col-span-2 md:col-span-2 row-span-2' : 'col-span-2 md:col-span-1'}`}
              data-testid={`gallery-video-${idx}`}
            >
              <video
                src={video.url}
                title={video.title}
                controls
                className="w-full h-full object-cover"
                poster={video.poster}
              >
                Votre navigateur ne supporte pas la lecture de vidéos.
              </video>
              <div className="absolute top-4 left-4 bg-[#0205B3] text-white px-3 py-1 rounded-full text-xs font-bold shadow-lg">
                {video.badge}
              </div>
            </div>
          ))}

          {/* Images */}
          {galleryImages.map((image) => (
            <div
              key={image.url}
              className="group relative aspect-square overflow-hidden rounded-2xl cursor-pointer shadow-lg hover:shadow-2xl transition-all duration-300"
              onClick={() => onSelectImage(image)}
              data-testid={`gallery-image-${image.url}`}
            >
              <img
                src={image.url}
                alt={image.alt || image.title}
                title={image.title}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-cyan-900/70 via-cyan-900/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-semibold text-sm">{image.title}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
